import React from 'react';
import JMHMap from '../JMHMap'

const Contact = () => (
  <section className="contact">
    <div className="contact--display">
      <p>
        <a className="contact--email" href="mailto:hello@jacquelynmoorehill.com">
          hello@jacquelynmoorehill.com
        </a>
      </p>
      <p>
        <span className="contact--social-media">
          <a href="https://www.pinterest.com/jqlynmoore/" target="_blank">
            pinterest
          </a>
        </span>
        <span className="contact--social-media">
          <a href="https://www.facebook.com/jmhinteriordesign/" target="_blank">
            facebook
          </a>
        </span>
        <span className="contact--social-media">
          <a href="https://www.instagram.com/jacquelynmoorehill/" target="_blank">
            instagram
          </a>
        </span>
      </p>
      <p>
        <a href="tel:718-757-1342">
          +1 718 757 1342
        </a>
      </p>
      <p>
        <a href="https://goo.gl/maps/DFzxJ3Ascjo" target="_blank">
          240 Kent Avenue - Suite A8 <br/>
          Brooklyn, NY 11249
        </a>
      </p>
    </div>
    <div className="contact--display">
      <JMHMap 
        latitude={40.716896} 
        longitude={-73.965750}
        zoom={15}
      />
    </div>
  </section>
)

export default Contact;


// WEBPACK FOOTER //
// ./components/page-contact/index.js